import React, { useEffect, useRef } from "react";
import WhiteContainer from "../components/whiteContainer";
import InvestmentMap from "../components/InvestmentMap";
import AboutSection from "../components/aboutsection";
import { useTranslation, Trans } from "react-i18next";
import "../styles/home.css";

import HomePageProperty from "../components/homepageproperty";
import ContactForm from "../components/contactform";

function Home() {
  const { t } = useTranslation();
  const rawLines = t("home.why.lines", { returnObjects: true });
  const whyKosovoLines = Array.isArray(rawLines) ? rawLines : [];

  const rawSteps = t("home.how.steps", { returnObjects: true });
  const howSteps = Array.isArray(rawSteps) ? rawSteps : [];

  const rawBuilt = t("home.built.lines", { returnObjects: true });
  const builtLines = Array.isArray(rawBuilt) ? rawBuilt : [];
  const rawIdeaSteps = t("home.idea.steps", { returnObjects: true });
  const ideaSteps = Array.isArray(rawIdeaSteps) ? rawIdeaSteps : [];

  const aboutRef = useRef(null);

  useEffect(() => {
    const section = aboutRef.current;
    let animated = false;

    const handleCounter = () => {
      const counters = section.querySelectorAll(".value-count");
      counters.forEach((counter) => {
        const target = +counter.getAttribute("data-target");
        const unit = counter.innerText.replace(/[0-9]/g, "");

        const updateCount = () => {
          const current = +counter.innerText.replace(/\D/g, "");
          const speed = 20;
          const increment = Math.ceil(target / speed);

          if (current < target) {
            counter.innerText = `${current + increment}${unit}`;
            setTimeout(updateCount, 30);
          } else {
            counter.innerText = `${target}${unit}`;
          }
        };

        updateCount();
      });
    };

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !animated) {
          handleCounter();
          animated = true;
        }
      },
      { threshold: 0.4 }
    );

    if (section) observer.observe(section);
    return () => observer.disconnect();
  }, []);

  return (
    <div className="home-page">
      <section className="hero" id="home">
        <div className="video-wrapper">
          <video
            className="hero-video"
            autoPlay
            muted
            loop
            playsInline
            src="/CoverVideo.mp4"
            type="video/mp4"
          />
        </div>
        <div className="green-circle circle-one"></div>
        <div className="green-circle circle-two"></div>
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="hero-title">
              {t("home.hero.titlePrefix")}{" "}
              <span className="word-rotate">
                <div>
                  <span className="future">{t("home.hero.words.future1")}</span>
                  <span className="vision">{t("home.hero.words.vision1")}</span>
                  <span className="growth">{t("home.hero.words.growth")}</span>
                  <span className="idea">{t("home.hero.words.idea1")}</span>
                  <span className="future">{t("home.hero.words.future2")}</span>
                  <span className="vision">{t("home.hero.words.vision2")}</span>
                  <span className="empire">{t("home.hero.words.empire")}</span>
                  <span className="idea">{t("home.hero.words.idea2")}</span>
                </div>
              </span>
            </h1>

            <p>{t("home.hero.subtitle")}</p>

            <a href="/#about">
              <img
                src="/downarrow.png"
                alt={t("home.hero.arrowAlt")}
                width={64}
                title="arrow"
              />
            </a>
          </div>
        </div>
      </section>
      <section className="whiteCont">
        <WhiteContainer />
      </section>
      <section>
        {/* Why Kosovo */}
        <section className="why-kosovo">
          <div className="container why-kosovo-content" style={{ marginTop: 50 }}>
            <div className="why-text">
              <h2>
                <Trans i18nKey="home.why.title">
                  Why <span>Kosovo</span>?
                </Trans>
              </h2>
              <div className="why-lines">
                {whyKosovoLines.map((line, i) => (
                  <p key={i}>{line}</p>
                ))}
              </div>
              <p className="why-callout">{t("home.why.callout")}</p>
            </div>
            <div className="why-image">
              <img
                src="/images/1.png"
                alt={t("home.why.imageAlt")}
                title="Kosova"
              />
            </div>
          </div>
        </section>

        {/* How It Works */}
        <section className="how-it-works">
          <div className="container how-it-works-content">
            <div className="how-text">
              <h2>
                <Trans i18nKey="home.how.title">
                  How It <span>Works</span>
                </Trans>
              </h2>
              <div className="how-steps">
                {howSteps.map((step, i) => (
                  <p key={i}>
                    <strong>{step.title}</strong> — {step.desc}
                  </p>
                ))}
              </div>
              <a href="#learnmore">
                <button className="hero-button">{t("home.how.button")}</button>
              </a>
            </div>
            <div className="how-image">
              <img src="/images/2.png" alt={t("home.how.imageAlt")} title="how" />
            </div>
          </div>
        </section>

        {/* Built for Progress */}
        <section className="why-kosovo">
          <div className="container why-kosovo-content">
            <div className="why-text">
              <h2>
                <Trans i18nKey="home.built.title">
                  Built for <span>Progress</span>
                </Trans>
              </h2>
              <div className="why-lines">
                {builtLines.map((line, i) => (
                  <p key={i}>{line}</p>
                ))}
              </div>
              <a href="/contact" target="__blank">
                <button className="hero-button">{t("home.built.button")}</button>
              </a>
            </div>
            <div className="why-image">
              <img src="/images/3.png" alt={t("home.built.imageAlt")} title="why" />
            </div>
          </div>
        </section>
      </section>


      <section className="about-eqera" ref={aboutRef} id="about">
        <AboutSection />
      </section>
      <section className="from-idea" id="learnmore">
        <div className="container from-idea-inner">
          {/* LEFT: SVG Graph Line with Blocks */}
          <div className="graph-visual">
            <img src="/images/Cover.png" alt={t("home.idea.imageAlt")} title="graph" />
          </div>

          <div className="steps-timeline">
            <h2>{t("home.idea.title")}</h2>

            {ideaSteps.map((step, i) => (
              <div className="timeline-item" key={i}>
                <div className="timeline-bullet"></div>
                <h3>{step.title}</h3>
                <p>{step.desc}</p>
              </div>
            ))}

            <div className="timeline-quote">{t("home.idea.quote")}</div>
          </div>
        </div>
      </section>
      <InvestmentMap />
      <HomePageProperty />
      <ContactForm />
    </div>
  );
}

export default Home;
